import React from 'react'
import styled from 'styled-components'
import { Mono } from '../../../../../../generic/ui/Mono'
import KbdChipButton from '../../../../../../generic/ui/KbdChipButton/KbdChipButton'
import MapPinIcon from '../../../../../../generic/icons/IconLib/MapPinIcon'
import XIcon from '../../../../../../generic/icons/IconLib/XIcon'

type Props = {
  code: string
  onClear: () => void
}

const ScannedLocationHeader = ({ code, onClear }: Props) => (
  <Header>
    <PinIcon><MapPinIcon /></PinIcon>
    <Code>{code}</Code>
    <KbdChipButton onClick={onClear} aria-label='ניקוי איתור' title='ניקוי איתור'>
      <XIcon size={16} />
    </KbdChipButton>
  </Header>
)

export default ScannedLocationHeader

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 0.875rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.line2};
`

const PinIcon = styled.span`
  color: ${({ theme }) => theme.colors.icon};
  display: inline-flex;
  align-items: center;

  svg {
    width: 1.125rem;
    height: 1.125rem;
  }
`

const Code = styled(Mono)`
  flex: 1;
  min-width: 0;
  font-size: ${({ theme }) => theme.text.lg};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.ink};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: ${({ theme }) => theme.textMobile.lg};
  }
`
